import { Competency, LearnerOutcome } from "@/lib/models";
import { OutcomeAreaCompetencyList } from "./OutcomeAreaCompetencyList";
import { HtmlRenderer } from "../HtmlRenderer";
import Image from "next/image";

type CompetencyDetailSidePanelProps = {
  learnerOutcome: LearnerOutcome;
  activeCompetency?: Competency;
  changeCompetency: (competencyId: string) => Promise<void>;
};

export const CompetencyDetailSidePanel = ({
  learnerOutcome,
  activeCompetency,
  changeCompetency,
}: CompetencyDetailSidePanelProps) => {
  return (
    <div
      className={`rounded-2xl border border-stone-200 shadow-lg ${
        activeCompetency ? "hidden" : "mx-2 mb-2"
      } col-span-full h-fit bg-white pb-2 medium:col-span-3 medium:block`}
    >
      <div className="hidden flex-col medium:flex">
        <div className="flex">
          <div className="my-4 ml-4 h-[48px] w-[42px]">
            {learnerOutcome.learnerOutcomeCard.sourceUrl && (
              <Image
                src={learnerOutcome.learnerOutcomeCard.sourceUrl}
                alt=""
                width={42}
                height={48}
              />
            )}
          </div>
          <div className="mx-3 flex w-[169px] flex-col justify-center text-left">
            <div className="pb-1 font-roobert text-[6px] font-medium uppercase text-black">
              Learner Outcome
            </div>
            <div className="font-roobert font-[16px] leading-none text-black">
              {learnerOutcome.name}
            </div>
          </div>
        </div>

        <div className="mx-4 mt-3 font-roobert text-[14px] text-gray-text">
          <HtmlRenderer html={learnerOutcome.description} />
        </div>
      </div>

      <div className="mt-4 hidden border-t border-tab-border medium:flex"></div>
      <h2 className="mx-4 mt-4 font-roobert text-xs font-medium uppercase leading-tight text-black">
        Competencies
      </h2>
      {learnerOutcome.outcomeAreas.map((outcomeAreaId) => (
        <OutcomeAreaCompetencyList
          key={outcomeAreaId}
          outcomeAreaId={outcomeAreaId}
          learnerOutcomeId={learnerOutcome.id}
          changeCompetency={changeCompetency}
        />
      ))}
    </div>
  );
};
